import styled from "styled-components";
import globalStyles from "../../data/constants/globalStyles";

export const AdmissionWrapper = styled.div`
    padding-top: ${globalStyles.other.navbarHeight};

    iframe {
        height: 500px;
        width: 100vw;
    }
`